/* eslint-disable no-useless-escape */
export const regex = {
  // minimum of 3 characters, must only contain numbers, letters, hyphens and underscores,
  assetIDAlphaNumeric: /^[a-zA-Z0-9-_]+[a-zA-Z0-9-_]+[a-zA-Z0-9-_]$/,
  assetIDStartEnd:
    /^[^-_!@#$£%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*[^-_!@#$£%^&*()_+\-=\[\]{};':"\\|,.<>\/?]$/, // can not start with hyphen, underscore or special char
};
